module.exports = __webpack_public_path__ + "img/attempt-icon.a8be4542.svg";